import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as groupCategoryActions from './../../../../actions/groupCategoryAction';
import GroupCategories from './GroupCategories';

const mapStateToProps = state => {
    return {
        groupCategoryState: state.groupCategoryReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllGroupCategories: (filters) => dispatch(groupCategoryActions.getAllGroupCategories(filters)),
        getGroupCategories: (filters) => dispatch(groupCategoryActions.getGroupCategories(filters)),
        setGroupCategories: (data) => dispatch(groupCategoryActions.setGroupCategories(data)),
        deleteGroupCategory: (groupCategory, refreshParams) => dispatch(groupCategoryActions.deleteGroupCategory(groupCategory, refreshParams))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(GroupCategories));
